import classNames from 'classnames';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

import type { DevicePlace } from '../../services/routes/places';
import { convertFromSmallestUnit } from '../../utils/validation';
import BalanceManager from '../BalanceManager';

import styles from './PlaceList.module.scss';

interface PlaceListProps {
  deviceId: number;
  places: DevicePlace[];
}

const PlaceList: React.FC<PlaceListProps> = ({ deviceId, places }) => {
  if (!places || places.length === 0) {
    return (
      <Container className={styles.container}>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Card.Text className={styles.emptyState}>Нет мест для отображения</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className={styles.container}>
      <Row>
        <Col>
          <h3 className={styles.title}>Игроки</h3>
        </Col>
      </Row>
      <Row>
        {places.map(place => (
          <Col
            key={`${place.device_id}-${place.place}`}
            xs={12}
            md={6}
            lg={4}
            className={styles.placeItem}
          >
            <Card className={classNames('mb-3')}>
              <Card.Body>
                <Card.Title>Игрок {place.place}</Card.Title>
                <Card.Text>
                  <span className={styles.balanceDisplay}>
                    Баланс:{' '}
                    {convertFromSmallestUnit(place.balances).toLocaleString('ru-RU', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{' '}
                    {place.currency}
                  </span>
                </Card.Text>
                <BalanceManager
                  deviceId={deviceId}
                  placeId={place.place}
                  currency={place.currency}
                />
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PlaceList;
